

// import React, { useState } from 'react';
// import {
//   BarChart,
//   Bar,
//   XAxis,
//   YAxis,
//   CartesianGrid,
//   Tooltip,
//   Legend,
//   ResponsiveContainer,
//   PieChart,
//   Pie,
//   Cell
// } from 'recharts';
// import html2pdf from 'html2pdf.js';
// import CalculatorForm from './CalculatorForm';
// import { motion } from 'framer-motion';

// const MarriageCalculator = () => {
//   const [currentAge, setCurrentAge] = useState(25);
//   const [marriageAge, setMarriageAge] = useState(30);
//   const [currentMarriageCost, setCurrentMarriageCost] = useState(1500000);
//   const [inflationRate, setInflationRate] = useState(6);
//   const [monthlyInvestment, setMonthlyInvestment] = useState(10000);
//   const [expectedReturn, setExpectedReturn] = useState(12);
//   const [existingSavings, setExistingSavings] = useState(200000);

//   const [showForm, setShowForm] = useState(false);
//   const [result, setResult] = useState(null);
//   const [chartData, setChartData] = useState([]);

//   const formatCurrency = (amount) => {
//     return `₹${Number(amount || 0).toLocaleString('en-IN', {
//       maximumFractionDigits: 0
//     })}`;
//   };

//   const calculate = () => {
//     if (marriageAge <= currentAge) {
//       alert('Marriage age should be greater than current age');
//       return;
//     }

//     const yearsToMarriage = marriageAge - currentAge;
//     const months = yearsToMarriage * 12;
//     const monthlyRate = expectedReturn / 12 / 100;

//     // Future wedding cost
//     const futureCost =
//       currentMarriageCost *
//       Math.pow(1 + inflationRate / 100, yearsToMarriage);

//     // Existing savings growth
//     const futureValueOfSavings =
//       existingSavings *
//       Math.pow(1 + expectedReturn / 100, yearsToMarriage);

//     // SIP growth
//     const futureValueOfSIP =
//       monthlyInvestment *
//       ((Math.pow(1 + monthlyRate, months) - 1) / monthlyRate) *
//       (1 + monthlyRate);

//     // Total corpus
//     const totalCorpus = futureValueOfSavings + futureValueOfSIP;

//     // Required SIP
//     const requiredMonthlySIP =
//       (futureCost * monthlyRate) /
//       ((Math.pow(1 + monthlyRate, months) - 1) *
//         (1 + monthlyRate));

//     const additionalMonthlyNeeded = Math.max(
//       0,
//       requiredMonthlySIP - monthlyInvestment
//     );

//     const fundingGap = Math.max(
//       0,
//       futureCost - totalCorpus
//     );

//     const percentageAchieved =
//       (totalCorpus / futureCost) * 100;

//     const isTargetReached = totalCorpus >= futureCost;

//     // Chart data
//     const data = [];

//     for (let year = 1; year <= yearsToMarriage; year++) {
//       const costAtYear =
//         currentMarriageCost *
//         Math.pow(1 + inflationRate / 100, year);

//       const savingsGrowth =
//         existingSavings *
//         Math.pow(1 + expectedReturn / 100, year);

//       const sipGrowth =
//         monthlyInvestment *
//         ((Math.pow(1 + monthlyRate, year * 12) - 1) /
//           monthlyRate) *
//         (1 + monthlyRate);

//       data.push({
//         year,
//         marriageCost: Math.round(costAtYear),
//         savingsAmount: Math.round(
//           savingsGrowth + sipGrowth
//         )
//       });
//     }

//     const pieData = [
//       {
//         name: 'Monthly SIP',
//         value: futureValueOfSIP
//       },
//       {
//         name: 'Existing Savings',
//         value: futureValueOfSavings
//       },
//       {
//         name: 'Funding Gap',
//         value: fundingGap
//       }
//     ].filter((item) => item.value > 0);

//     setResult({
//       futureCost,
//       totalCorpus,
//       futureValueOfSavings,
//       futureValueOfSIP,
//       requiredMonthlySIP,
//       additionalMonthlyNeeded,
//       fundingGap,
//       percentageAchieved,
//       isTargetReached,
//       yearsToMarriage,
//       months,
//       pieData
//     });

//     setChartData(data);
//   };

//   const handleFormSubmit = (userData) => {
//     const element = document.getElementById(
//       'marriage-result-content'
//     );

//     const options = {
//       margin: 0.5,
//       filename: `Marriage_Plan_${userData.name}.pdf`,
//       image: {
//         type: 'jpeg',
//         quality: 1
//       },
//       html2canvas: {
//         scale: 2
//       },
//       jsPDF: {
//         unit: 'in',
//         format: 'a4',
//         orientation: 'portrait'
//       }
//     };

//     html2pdf()
//       .set(options)
//       .from(element)
//       .save();

//     setShowForm(false);

//     const status = result.isTargetReached
//       ? '✅ You are on track for your dream wedding!'
//       : `⚠️ Increase savings by ${formatCurrency(
//           result.additionalMonthlyNeeded
//         )}/month`;

//     const whatsappMessage = `Dear ${
//       userData.name
//     },

// 💒 Marriage Planning Summary

// • Current Age: ${currentAge} years
// • Marriage Age: ${marriageAge} years
// • Current Wedding Cost: ${formatCurrency(
//       currentMarriageCost
//     )}
// • Future Wedding Cost: ${formatCurrency(
//       result.futureCost
//     )}
// • Existing Savings: ${formatCurrency(
//       existingSavings
//     )}
// • Monthly SIP: ${formatCurrency(
//       monthlyInvestment
//     )}
// • Expected Corpus: ${formatCurrency(
//       result.totalCorpus
//     )}

// ${status}

// For personalized financial planning:

// 📞 9726344477
// 📧 Wisdom2secure@gmail.com

// - Wisdom Consultancy`;

//     window.open(
//       `https://wa.me/${
//         userData.phone
//       }?text=${encodeURIComponent(
//         whatsappMessage
//       )}`,
//       '_blank'
//     );
//   };

//   const weddingTypes = [
//     {
//       name: 'Simple',
//       cost: 500000
//     },
//     {
//       name: 'Traditional',
//       cost: 1000000
//     },
//     {
//       name: 'Premium',
//       cost: 2000000
//     },
//     {
//       name: 'Luxury',
//       cost: 3500000
//     },
//     {
//       name: 'Destination',
//       cost: 5000000
//     }
//   ];

//   const COLORS = [
//     '#1e3c72',
//     '#2a5298',
//     '#ff6b35'
//   ];

//   return (
//     <motion.div
//       initial={{ opacity: 0, y: 20 }}
//       animate={{ opacity: 1, y: 0 }}
//       className="bg-white rounded-2xl shadow-xl p-6 md:p-8"
//     >
//       <div className="mb-8">
//         <h3 className="text-3xl font-bold text-primary mb-2">
//           Marriage Planning Calculator
//         </h3>

//         <p className="text-gray-600">
//           Plan your dream wedding with smart
//           financial planning
//         </p>
//       </div>

//       <div className="grid md:grid-cols-2 gap-8">
//         {/* LEFT SECTION */}
//         <div className="space-y-6">
//           {/* Current Age */}
//           <div>
//             <label className="block font-semibold text-gray-700 mb-2">
//               Current Age
//             </label>

//             <input
//               type="range"
//               min="18"
//               max="50"
//               value={currentAge}
//               onChange={(e) =>
//                 setCurrentAge(
//                   Number(e.target.value)
//                 )
//               }
//               className="w-full"
//             />

//             <div className="text-center font-bold text-primary mt-2">
//               {currentAge} years
//             </div>
//           </div>

//           {/* Marriage Age */}
//           <div>
//             <label className="block font-semibold text-gray-700 mb-2">
//               Marriage Age
//             </label>

//             <input
//               type="range"
//               min={currentAge + 1}
//               max="60"
//               value={marriageAge}
//               onChange={(e) =>
//                 setMarriageAge(
//                   Number(e.target.value)
//                 )
//               }
//               className="w-full"
//             />

//             <div className="text-center font-bold text-primary mt-2">
//               {marriageAge} years
//             </div>

//             <p className="text-sm text-gray-500 text-center mt-1">
//               Planning Period:{' '}
//               {marriageAge - currentAge} years
//             </p>
//           </div>

//           {/* Wedding Cost */}
//           <div>
//             <label className="block font-semibold text-gray-700 mb-2">
//               Current Wedding Cost
//             </label>

//             <input
//               type="number"
//               value={currentMarriageCost}
//               onChange={(e) =>
//                 setCurrentMarriageCost(
//                   Number(e.target.value)
//                 )
//               }
//               className="input-field"
//             />

//             <div className="flex flex-wrap gap-2 mt-3">
//               {weddingTypes.map(
//                 (item, index) => (
//                   <button
//                     key={index}
//                     type="button"
//                     onClick={() =>
//                       setCurrentMarriageCost(
//                         item.cost
//                       )
//                     }
//                     className="px-3 py-1 rounded-full bg-gray-100 hover:bg-primary hover:text-white text-sm transition"
//                   >
//                     {item.name}
//                   </button>
//                 )
//               )}
//             </div>
//           </div>

//           {/* Inflation */}
//           <div>
//             <label className="block font-semibold text-gray-700 mb-2">
//               Inflation Rate
//             </label>

//             <input
//               type="range"
//               min="2"
//               max="15"
//               step="0.5"
//               value={inflationRate}
//               onChange={(e) =>
//                 setInflationRate(
//                   Number(e.target.value)
//                 )
//               }
//               className="w-full"
//             />

//             <div className="text-center font-bold text-primary mt-2">
//               {inflationRate}%
//             </div>
//           </div>

//           {/* Existing Savings */}
//           <div>
//             <label className="block font-semibold text-gray-700 mb-2">
//               Existing Savings
//             </label>

//             <input
//               type="number"
//               value={existingSavings}
//               onChange={(e) =>
//                 setExistingSavings(
//                   Number(e.target.value)
//                 )
//               }
//               className="input-field"
//             />
//           </div>

//           {/* Monthly SIP */}
//           <div>
//             <label className="block font-semibold text-gray-700 mb-2">
//               Monthly SIP
//             </label>

//             <input
//               type="number"
//               value={monthlyInvestment}
//               onChange={(e) =>
//                 setMonthlyInvestment(
//                   Number(e.target.value)
//                 )
//               }
//               className="input-field"
//             />
//           </div>

//           {/* Return */}
//           <div>
//             <label className="block font-semibold text-gray-700 mb-2">
//               Expected Return
//             </label>

//             <input
//               type="range"
//               min="4"
//               max="20"
//               step="0.5"
//               value={expectedReturn}
//               onChange={(e) =>
//                 setExpectedReturn(
//                   Number(e.target.value)
//                 )
//               }
//               className="w-full"
//             />

//             <div className="text-center font-bold text-primary mt-2">
//               {expectedReturn}%
//             </div>
//           </div>

//           <button
//             onClick={calculate}
//             className="w-full bg-primary text-white py-3 rounded-xl font-semibold hover:opacity-90 transition"
//           >
//             Calculate Marriage Plan
//           </button>
//         </div>

//         {/* RIGHT SECTION */}
//         {result && (
//           <div className="space-y-5">
//             {/* Summary Card */}
//             <div className="bg-gradient-to-br from-pink-50 to-purple-50 rounded-2xl p-6">
//               <h4 className="text-xl font-bold text-primary mb-5">
//                 💒 Wedding Planning Summary
//               </h4>

//               <div className="space-y-4">
//                 <div className="flex justify-between border-b pb-2">
//                   <span>Future Wedding Cost</span>
//                   <span className="font-bold text-primary">
//                     {formatCurrency(
//                       result.futureCost
//                     )}
//                   </span>
//                 </div>

//                 <div className="flex justify-between border-b pb-2">
//                   <span>Total Expected Corpus</span>
//                   <span className="font-semibold">
//                     {formatCurrency(
//                       result.totalCorpus
//                     )}
//                   </span>
//                 </div>

//                 <div className="flex justify-between border-b pb-2">
//                   <span>Required Monthly SIP</span>
//                   <span className="font-semibold">
//                     {formatCurrency(
//                       result.requiredMonthlySIP
//                     )}
//                   </span>
//                 </div>

//                 <div>
//                   <div className="flex justify-between text-sm mb-1">
//                     <span>Goal Achievement</span>
//                     <span className="font-semibold">
//                       {Math.min(
//                         result.percentageAchieved,
//                         100
//                       ).toFixed(1)}
//                       %
//                     </span>
//                   </div>

//                   <div className="w-full bg-gray-200 rounded-full h-3">
//                     <div
//                       className={`h-3 rounded-full ${
//                         result.isTargetReached
//                           ? 'bg-green-500'
//                           : 'bg-orange-500'
//                       }`}
//                       style={{
//                         width: `${Math.min(
//                           result.percentageAchieved,
//                           100
//                         )}%`
//                       }}
//                     />
//                   </div>
//                 </div>

//                 <div
//                   className={`p-4 rounded-xl ${
//                     result.isTargetReached
//                       ? 'bg-green-100 text-green-700'
//                       : 'bg-orange-100 text-orange-700'
//                   }`}
//                 >
//                   {result.isTargetReached ? (
//                     <p className="font-semibold">
//                       ✓ You are on track for your
//                       dream wedding!
//                     </p>
//                   ) : (
//                     <>
//                       <p className="font-semibold">
//                         Increase Monthly SIP
//                       </p>

//                       <p className="mt-1">
//                         Additional Needed:{' '}
//                         <strong>
//                           {formatCurrency(
//                             result.additionalMonthlyNeeded
//                           )}
//                           /month
//                         </strong>
//                       </p>
//                     </>
//                   )}
//                 </div>
//               </div>
//             </div>

//             {/* Pie Chart */}
//             <div className="bg-white border rounded-2xl p-4">
//               <h5 className="font-bold text-primary mb-3">
//                 Funding Sources
//               </h5>

//               <div className="h-60">
//                 <ResponsiveContainer
//                   width="100%"
//                   height="100%"
//                 >
//                   <PieChart>
//                     <Pie
//                       data={result.pieData}
//                       dataKey="value"
//                       cx="50%"
//                       cy="50%"
//                       outerRadius={80}
//                       label={({ name, percent }) =>
//                         `${name} ${(
//                           percent * 100
//                         ).toFixed(0)}%`
//                       }
//                     >
//                       {result.pieData.map(
//                         (entry, index) => (
//                           <Cell
//                             key={index}
//                             fill={
//                               COLORS[
//                                 index %
//                                   COLORS.length
//                               ]
//                             }
//                           />
//                         )
//                       )}
//                     </Pie>

//                     <Tooltip
//                       formatter={(value) =>
//                         formatCurrency(value)
//                       }
//                     />
//                   </PieChart>
//                 </ResponsiveContainer>
//               </div>
//             </div>
//           </div>
//         )}
//       </div>

//       {/* BAR CHART */}
//       {chartData.length > 0 && (
//         <div className="mt-10">
//           <h4 className="text-xl font-bold text-primary mb-4">
//             Wedding Cost vs Savings Projection
//           </h4>

//           <div className="h-96 bg-white rounded-2xl border p-4">
//             <ResponsiveContainer
//               width="100%"
//               height="100%"
//             >
//               <BarChart data={chartData}>
//                 <CartesianGrid strokeDasharray="3 3" />

//                 <XAxis dataKey="year" />

//                 <YAxis />

//                 <Tooltip
//                   formatter={(value) =>
//                     formatCurrency(value)
//                   }
//                 />

//                 <Legend />

//                 <Bar
//                   dataKey="marriageCost"
//                   fill="#ff6b35"
//                   name="Wedding Cost"
//                   radius={[8, 8, 0, 0]}
//                 />

//                 <Bar
//                   dataKey="savingsAmount"
//                   fill="#1e3c72"
//                   name="Your Savings"
//                   radius={[8, 8, 0, 0]}
//                 />
//               </BarChart>
//             </ResponsiveContainer>
//           </div>
//         </div>
//       )}

//       {/* TIPS */}
//       <div className="mt-8 bg-pink-50 border border-pink-200 rounded-2xl p-5">
//         <h5 className="font-bold text-pink-800 mb-3">
//           💡 Wedding Planning Tips
//         </h5>

//         <ul className="space-y-2 text-sm text-pink-700">
//           <li>
//             • Start investing early for better
//             compounding
//           </li>

//           <li>
//             • Increase SIP every year with salary
//             growth
//           </li>

//           <li>
//             • Avoid taking high-interest wedding
//             loans
//           </li>

//           <li>
//             • Keep emergency savings separate from
//             wedding funds
//           </li>

//           <li>
//             • Use balanced mutual funds for
//             medium-term goals
//           </li>
//         </ul>
//       </div>

//       {/* PDF CONTENT */}
//       {result && (
//         <div
//           id="marriage-result-content"
//           style={{ display: 'none' }}
//         >
//           <div
//             style={{
//               padding: '30px',
//               fontFamily: 'Arial'
//             }}
//           >
//             <div
//               style={{
//                 textAlign: 'center',
//                 marginBottom: '20px'
//               }}
//             >
//               <h1 style={{ color: '#1e3c72' }}>
//                 Wisdom Consultancy
//               </h1>

//               <p>
//                 E-44, Vasant Vihar Society,
//                 Vadodara
//               </p>

//               <p>
//                 📞 9726344477 | ✉️
//                 Wisdom2secure@gmail.com
//               </p>

//               <hr />

//               <h2>Marriage Planning Report</h2>
//             </div>

//             <table
//               style={{
//                 width: '100%',
//                 borderCollapse: 'collapse'
//               }}
//             >
//               <tbody>
//                 <tr>
//                   <td
//                     style={{ padding: '10px' }}
//                   >
//                     Current Age
//                   </td>

//                   <td>
//                     {currentAge} years
//                   </td>
//                 </tr>

//                 <tr>
//                   <td
//                     style={{ padding: '10px' }}
//                   >
//                     Marriage Age
//                   </td>

//                   <td>
//                     {marriageAge} years
//                   </td>
//                 </tr>

//                 <tr>
//                   <td
//                     style={{ padding: '10px' }}
//                   >
//                     Future Wedding Cost
//                   </td>

//                   <td>
//                     {formatCurrency(
//                       result.futureCost
//                     )}
//                   </td>
//                 </tr>

//                 <tr>
//                   <td
//                     style={{ padding: '10px' }}
//                   >
//                     Total Corpus
//                   </td>

//                   <td>
//                     {formatCurrency(
//                       result.totalCorpus
//                     )}
//                   </td>
//                 </tr>

//                 <tr>
//                   <td
//                     style={{ padding: '10px' }}
//                   >
//                     Required SIP
//                   </td>

//                   <td>
//                     {formatCurrency(
//                       result.requiredMonthlySIP
//                     )}
//                   </td>
//                 </tr>

//                 <tr>
//                   <td
//                     style={{ padding: '10px' }}
//                   >
//                     Goal Status
//                   </td>

//                   <td>
//                     {result.isTargetReached
//                       ? 'On Track ✓'
//                       : 'Need More Savings'}
//                   </td>
//                 </tr>
//               </tbody>
//             </table>

//             <div
//               style={{
//                 marginTop: '30px',
//                 textAlign: 'center',
//                 color: '#666',
//                 fontSize: '12px'
//               }}
//             >
//               <p>
//                 This is a system-generated
//                 financial planning report.
//               </p>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* DOWNLOAD BUTTON */}
//       {result && (
//         <button
//           onClick={() => setShowForm(true)}
//           className="w-full mt-8 bg-green-600 hover:bg-green-700 text-white py-3 rounded-xl font-semibold transition"
//         >
//           📄 Download Report & Share on WhatsApp
//         </button>
//       )}

//       {/* FORM */}
//       {showForm && (
//         <CalculatorForm
//           onSubmit={handleFormSubmit}
//           onClose={() =>
//             setShowForm(false)
//           }
//           calculatorType="Marriage"
//         />
//       )}
//     </motion.div>
//   );
// };

// export default MarriageCalculator;

import React, { useState } from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
  PieChart,
  Pie,
  Cell,
  AreaChart,
  Area,
} from 'recharts';

import html2pdf from 'html2pdf.js';
import CalculatorForm from './CalculatorForm';

import { motion } from 'framer-motion';

import {
  FaHeart,
  FaChartLine,
  FaPiggyBank,
  FaFilePdf,
  FaWhatsapp,
  FaRupeeSign,
  FaRing,
} from 'react-icons/fa';

const MarriageCalculator = () => {
  const [currentAge, setCurrentAge] = useState(25);
  const [marriageAge, setMarriageAge] = useState(30);

  const [currentMarriageCost, setCurrentMarriageCost] =
    useState(1500000);

  const [inflationRate, setInflationRate] =
    useState(6);

  const [monthlyInvestment, setMonthlyInvestment] =
    useState(10000);

  const [expectedReturn, setExpectedReturn] =
    useState(12);

  const [existingSavings, setExistingSavings] =
    useState(200000);

  const [annualStepUp, setAnnualStepUp] =
    useState(10);

  const [showForm, setShowForm] = useState(false);

  const [result, setResult] = useState(null);

  const [chartData, setChartData] = useState([]);

  const formatCurrency = (amount) => {
    return `₹${Number(
      amount || 0
    ).toLocaleString('en-IN', {
      maximumFractionDigits: 0,
    })}`;
  };

  const calculate = () => {
    if (marriageAge <= currentAge) {
      alert(
        'Marriage age should be greater than current age'
      );
      return;
    }

    const yearsToMarriage =
      marriageAge - currentAge;

    const months = yearsToMarriage * 12;

    const monthlyRate =
      expectedReturn / 12 / 100;

    // Future Marriage Cost
    const futureCost =
      currentMarriageCost *
      Math.pow(
        1 + inflationRate / 100,
        yearsToMarriage
      );

    // Existing Savings Growth
    const futureValueOfSavings =
      existingSavings *
      Math.pow(
        1 + expectedReturn / 100,
        yearsToMarriage
      );

    // SIP Growth with Step-Up
    let sipFutureValue = 0;

    for (
      let year = 1;
      year <= yearsToMarriage;
      year++
    ) {
      const increasedSIP =
        monthlyInvestment *
        Math.pow(
          1 + annualStepUp / 100,
          year - 1
        );

      const remainingMonths =
        (yearsToMarriage - year + 1) * 12;

      const fv =
        increasedSIP *
        ((Math.pow(
          1 + monthlyRate,
          remainingMonths
        ) -
          1) /
          monthlyRate) *
        (1 + monthlyRate);

      sipFutureValue += fv;
    }

    const totalCorpus =
      futureValueOfSavings +
      sipFutureValue;

    // Required SIP
    const requiredMonthlySIP =
      (futureCost * monthlyRate) /
      ((Math.pow(
        1 + monthlyRate,
        months
      ) -
        1) *
        (1 + monthlyRate));

    const additionalMonthlyNeeded =
      Math.max(
        0,
        requiredMonthlySIP -
          monthlyInvestment
      );

    const fundingGap = Math.max(
      0,
      futureCost - totalCorpus
    );

    const percentageAchieved =
      (totalCorpus / futureCost) * 100;

    const isTargetReached =
      totalCorpus >= futureCost;

    // Projection Data
    const data = [];

    for (
      let year = 1;
      year <= yearsToMarriage;
      year++
    ) {
      const costAtYear =
        currentMarriageCost *
        Math.pow(
          1 + inflationRate / 100,
          year
        );

      const savingsGrowth =
        existingSavings *
        Math.pow(
          1 + expectedReturn / 100,
          year
        );

      const yearlySIP =
        monthlyInvestment *
        Math.pow(
          1 + annualStepUp / 100,
          year - 1
        );

      const sipGrowth =
        yearlySIP *
        ((Math.pow(
          1 + monthlyRate,
          year * 12
        ) -
          1) /
          monthlyRate) *
        (1 + monthlyRate);

      data.push({
        year: `Year ${year}`,
        marriageCost:
          Math.round(costAtYear),

        savingsAmount: Math.round(
          savingsGrowth + sipGrowth
        ),
      });
    }

    const pieData = [
      {
        name: 'SIP Investment',
        value: sipFutureValue,
      },
      {
        name: 'Existing Savings',
        value: futureValueOfSavings,
      },
      {
        name: 'Funding Gap',
        value: fundingGap,
      },
    ].filter((item) => item.value > 0);

    setResult({
      futureCost,
      totalCorpus,
      futureValueOfSavings,
      sipFutureValue,
      requiredMonthlySIP,
      additionalMonthlyNeeded,
      fundingGap,
      percentageAchieved,
      isTargetReached,
      yearsToMarriage,
      pieData,
    });

    setChartData(data);
  };

  const handleFormSubmit = (userData) => {
    const element = document.getElementById(
      'marriage-result-content'
    );

    const options = {
      margin: 0.5,
      filename: `Marriage_Planning_${userData.name}.pdf`,
      image: {
        type: 'jpeg',
        quality: 1,
      },
      html2canvas: {
        scale: 2,
      },
      jsPDF: {
        unit: 'in',
        format: 'a4',
        orientation: 'portrait',
      },
    };

    html2pdf()
      .set(options)
      .from(element)
      .save();

    setShowForm(false);

    const whatsappMessage = `
Dear ${userData.name},

💒 Marriage Planning Summary

👤 Current Age: ${currentAge} Years
💍 Marriage Age: ${marriageAge} Years

💰 Current Wedding Cost:
${formatCurrency(
      currentMarriageCost
    )}

📈 Future Wedding Cost:
${formatCurrency(result.futureCost)}

💵 Total Expected Corpus:
${formatCurrency(result.totalCorpus)}

📊 Goal Achievement:
${Math.min(
      result.percentageAchieved,
      100
    ).toFixed(1)}%

${
  result.isTargetReached
    ? '✅ Congratulations! Your wedding planning is on track.'
    : `⚠️ Increase Monthly SIP by ${formatCurrency(
        result.additionalMonthlyNeeded
      )}`
}

For personalized financial planning:

📞 9726344477
📧 wisdom2secure@gmail.com

- Wisdom Consultancy
`;

    window.open(
      `https://wa.me/${
        userData.phone
      }?text=${encodeURIComponent(
        whatsappMessage
      )}`,
      '_blank'
    );
  };

  const weddingTypes = [
    {
      name: 'Simple',
      cost: 500000,
    },
    {
      name: 'Traditional',
      cost: 1200000,
    },
    {
      name: 'Premium',
      cost: 2500000,
    },
    {
      name: 'Luxury',
      cost: 4500000,
    },
    {
      name: 'Destination',
      cost: 7000000,
    },
  ];

  const COLORS = [
    '#2e56b8',
    '#69bf74',
    '#ff8c42',
  ];

  return (
    <motion.div
      initial={{
        opacity: 0,
        y: 20,
      }}
      animate={{
        opacity: 1,
        y: 0,
      }}
      className="bg-white rounded-[32px] shadow-2xl p-6 md:p-10 border border-[#edf3ff]"
    >
      {/* HEADER */}
      <div className="flex items-center gap-4 mb-10">
        <div className="w-16 h-16 rounded-2xl bg-pink-100 flex items-center justify-center text-pink-600 text-3xl">
          <FaRing />
        </div>

        <div>
          <h2 className="text-3xl font-bold text-[#0b1c39]">
            Marriage Planning Calculator
          </h2>

          <p className="text-gray-600 mt-1">
            Plan your dream wedding with
            smart financial planning &
            inflation-adjusted projections.
          </p>
        </div>
      </div>

      <div className="grid lg:grid-cols-2 gap-10">
        {/* LEFT */}
        <div className="space-y-6">
          {/* Current Age */}
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-3">
              Current Age
            </label>

            <input
              type="range"
              min="18"
              max="50"
              value={currentAge}
              onChange={(e) =>
                setCurrentAge(
                  Number(e.target.value)
                )
              }
              className="w-full accent-[#2e56b8]"
            />

            <div className="text-center mt-2 font-bold text-[#2e56b8]">
              {currentAge} Years
            </div>
          </div>

          {/* Marriage Age */}
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-3">
              Marriage Age
            </label>

            <input
              type="range"
              min={currentAge + 1}
              max="60"
              value={marriageAge}
              onChange={(e) =>
                setMarriageAge(
                  Number(e.target.value)
                )
              }
              className="w-full accent-pink-500"
            />

            <div className="text-center mt-2 font-bold text-pink-600">
              {marriageAge} Years
            </div>
          </div>

          {/* Wedding Cost */}
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-3">
              Current Wedding Cost
            </label>

            <input
              type="number"
              value={currentMarriageCost}
              onChange={(e) =>
                setCurrentMarriageCost(
                  Number(e.target.value)
                )
              }
              className="w-full border border-gray-300 rounded-xl px-4 py-3 outline-none focus:border-[#2e56b8]"
            />

            <div className="flex flex-wrap gap-2 mt-3">
              {weddingTypes.map(
                (item, index) => (
                  <button
                    key={index}
                    type="button"
                    onClick={() =>
                      setCurrentMarriageCost(
                        item.cost
                      )
                    }
                    className="px-3 py-2 bg-[#edf3ff] text-[#2e56b8] rounded-full text-xs font-semibold hover:bg-[#dbe7ff] transition-all"
                  >
                    {item.name}
                  </button>
                )
              )}
            </div>
          </div>

          {/* Inflation */}
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-3">
              Wedding Inflation Rate
            </label>

            <input
              type="range"
              min="2"
              max="15"
              step="0.5"
              value={inflationRate}
              onChange={(e) =>
                setInflationRate(
                  Number(e.target.value)
                )
              }
              className="w-full accent-orange-500"
            />

            <div className="text-center mt-2 font-bold text-orange-500">
              {inflationRate}%
            </div>
          </div>

          {/* Existing Savings */}
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-3">
              Existing Savings
            </label>

            <input
              type="number"
              value={existingSavings}
              onChange={(e) =>
                setExistingSavings(
                  Number(e.target.value)
                )
              }
              className="w-full border border-gray-300 rounded-xl px-4 py-3 outline-none focus:border-[#2e56b8]"
            />
          </div>

          {/* SIP */}
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-3">
              Monthly SIP Investment
            </label>

            <input
              type="number"
              value={monthlyInvestment}
              onChange={(e) =>
                setMonthlyInvestment(
                  Number(e.target.value)
                )
              }
              className="w-full border border-gray-300 rounded-xl px-4 py-3 outline-none focus:border-[#2e56b8]"
            />
          </div>

          {/* Step Up */}
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-3">
              Annual SIP Step-Up
            </label>

            <input
              type="range"
              min="0"
              max="20"
              step="1"
              value={annualStepUp}
              onChange={(e) =>
                setAnnualStepUp(
                  Number(e.target.value)
                )
              }
              className="w-full accent-green-500"
            />

            <div className="text-center mt-2 font-bold text-green-600">
              {annualStepUp}%
            </div>
          </div>

          {/* Return */}
          <div>
            <label className="block text-sm font-semibold text-gray-700 mb-3">
              Expected Return
            </label>

            <input
              type="range"
              min="4"
              max="20"
              step="0.5"
              value={expectedReturn}
              onChange={(e) =>
                setExpectedReturn(
                  Number(e.target.value)
                )
              }
              className="w-full accent-[#2e56b8]"
            />

            <div className="text-center mt-2 font-bold text-[#2e56b8]">
              {expectedReturn}%
            </div>
          </div>

          <button
            onClick={calculate}
            className="w-full bg-[#2e56b8] hover:bg-[#24479b] text-white py-4 rounded-2xl font-semibold text-lg transition-all duration-300 shadow-lg"
          >
            Calculate Marriage Plan
          </button>
        </div>

        {/* RIGHT */}
        {result && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            className="bg-gradient-to-br from-pink-50 to-[#edf3ff] rounded-[30px] p-8"
          >
            <div className="flex items-center gap-3 mb-6">
              <FaHeart className="text-pink-600 text-2xl" />

              <h4 className="text-2xl font-bold text-[#0b1c39]">
                Marriage Planning Summary
              </h4>
            </div>

            <div className="space-y-5">
              <div className="flex justify-between border-b pb-3">
                <span className="text-gray-600">
                  Future Wedding Cost
                </span>

                <span className="font-bold text-pink-600">
                  {formatCurrency(
                    result.futureCost
                  )}
                </span>
              </div>

              <div className="flex justify-between border-b pb-3">
                <span className="text-gray-600">
                  Total Corpus
                </span>

                <span className="font-bold text-[#2e56b8]">
                  {formatCurrency(
                    result.totalCorpus
                  )}
                </span>
              </div>

              <div className="flex justify-between border-b pb-3">
                <span className="text-gray-600">
                  Existing Savings Growth
                </span>

                <span className="font-semibold">
                  {formatCurrency(
                    result.futureValueOfSavings
                  )}
                </span>
              </div>

              <div className="flex justify-between border-b pb-3">
                <span className="text-gray-600">
                  SIP Growth
                </span>

                <span className="font-semibold">
                  {formatCurrency(
                    result.sipFutureValue
                  )}
                </span>
              </div>

              <div className="flex justify-between border-b pb-3">
                <span className="text-gray-600">
                  Required Monthly SIP
                </span>

                <span className="font-bold">
                  {formatCurrency(
                    result.requiredMonthlySIP
                  )}
                </span>
              </div>

              {/* Progress */}
              <div className="mt-6">
                <div className="flex justify-between text-sm mb-2">
                  <span>
                    Goal Achievement
                  </span>

                  <span className="font-semibold">
                    {Math.min(
                      result.percentageAchieved,
                      100
                    ).toFixed(1)}
                    %
                  </span>
                </div>

                <div className="w-full h-3 bg-gray-200 rounded-full overflow-hidden">
                  <div
                    className={`h-full ${
                      result.isTargetReached
                        ? 'bg-green-500'
                        : 'bg-orange-500'
                    }`}
                    style={{
                      width: `${Math.min(
                        result.percentageAchieved,
                        100
                      )}%`,
                    }}
                  />
                </div>
              </div>

              {/* Status */}
              <div
                className={`mt-6 p-5 rounded-2xl ${
                  result.isTargetReached
                    ? 'bg-green-100'
                    : 'bg-orange-100'
                }`}
              >
                {result.isTargetReached ? (
                  <p className="font-semibold text-green-700">
                    ✅ Excellent! Your wedding
                    planning is on track.
                  </p>
                ) : (
                  <>
                    <p className="font-semibold text-orange-700">
                      ⚠ Increase Monthly SIP
                    </p>

                    <p className="mt-2 text-orange-700">
                      Additional SIP Needed:
                    </p>

                    <p className="font-bold text-xl mt-1 text-orange-700">
                      {formatCurrency(
                        result.additionalMonthlyNeeded
                      )}
                      /month
                    </p>
                  </>
                )}
              </div>
            </div>
          </motion.div>
        )}
      </div>

      {/* CHARTS */}
      {chartData.length > 0 && (
        <div className="grid lg:grid-cols-2 gap-8 mt-12">
          {/* Area Chart */}
          <div className="bg-[#f8fbff] rounded-[30px] p-5 h-[400px]">
            <div className="flex items-center gap-3 mb-5">
              <FaChartLine className="text-[#2e56b8]" />

              <h4 className="text-xl font-bold text-[#0b1c39]">
                Savings Projection
              </h4>
            </div>

            <ResponsiveContainer
              width="100%"
              height="90%"
            >
              <AreaChart data={chartData}>
                <defs>
                  <linearGradient
                    id="colorSavings"
                    x1="0"
                    y1="0"
                    x2="0"
                    y2="1"
                  >
                    <stop
                      offset="5%"
                      stopColor="#2e56b8"
                      stopOpacity={0.8}
                    />
                    <stop
                      offset="95%"
                      stopColor="#2e56b8"
                      stopOpacity={0}
                    />
                  </linearGradient>
                </defs>

                <CartesianGrid strokeDasharray="3 3" />

                <XAxis dataKey="year" />

                <YAxis />

                <Tooltip
                  formatter={(value) =>
                    formatCurrency(value)
                  }
                />

                <Legend />

                <Area
                  type="monotone"
                  dataKey="savingsAmount"
                  stroke="#2e56b8"
                  fillOpacity={1}
                  fill="url(#colorSavings)"
                  name="Savings"
                />

                <Bar
                  dataKey="marriageCost"
                  fill="#ff8c42"
                  name="Marriage Cost"
                />
              </AreaChart>
            </ResponsiveContainer>
          </div>

          {/* Pie Chart */}
          <div className="bg-white border rounded-[30px] p-5 h-[400px]">
            <div className="flex items-center gap-3 mb-5">
              <FaPiggyBank className="text-[#69bf74]" />

              <h4 className="text-xl font-bold text-[#0b1c39]">
                Funding Sources
              </h4>
            </div>

            <ResponsiveContainer
              width="100%"
              height="90%"
            >
              <PieChart>
                <Pie
                  data={result.pieData}
                  dataKey="value"
                  cx="50%"
                  cy="50%"
                  outerRadius={100}
                  label={({
                    name,
                    percent,
                  }) =>
                    `${name} ${(
                      percent * 100
                    ).toFixed(0)}%`
                  }
                >
                  {result.pieData.map(
                    (entry, index) => (
                      <Cell
                        key={index}
                        fill={
                          COLORS[
                            index %
                              COLORS.length
                          ]
                        }
                      />
                    )
                  )}
                </Pie>

                <Tooltip
                  formatter={(value) =>
                    formatCurrency(value)
                  }
                />
              </PieChart>
            </ResponsiveContainer>
          </div>
        </div>
      )}

      {/* TIPS */}
      <div className="mt-10 bg-pink-50 border border-pink-200 rounded-[30px] p-6">
        <h5 className="text-xl font-bold text-pink-700 mb-4">
          💡 Marriage Planning Tips
        </h5>

        <ul className="space-y-2 text-pink-700">
          <li>
            • Start investing early for
            better compounding benefits.
          </li>

          <li>
            • Increase SIP yearly to beat
            inflation.
          </li>

          <li>
            • Keep wedding funds separate
            from emergency funds.
          </li>

          <li>
            • Avoid taking high-interest
            wedding loans.
          </li>

          <li>
            • Diversify investments for
            medium-term financial goals.
          </li>
        </ul>
      </div>

      {/* PDF */}
      {result && (
        <div
          id="marriage-result-content"
          style={{ display: 'none' }}
        >
          <div
            style={{
              padding: '30px',
              fontFamily: 'Arial',
            }}
          >
            <div
              style={{
                textAlign: 'center',
                borderBottom:
                  '2px solid #1e3c72',
                paddingBottom: '20px',
                marginBottom: '20px',
              }}
            >
              <h1
                style={{
                  color: '#1e3c72',
                }}
              >
                Wisdom Consultancy
              </h1>

              <p>
                E-44, Vasant Vihar Society,
                GIDC-Vadsar Road,
                Vadodara-390010
              </p>

              <p>
                📞 9726344477 |
                ✉ wisdom2secure@gmail.com
              </p>

              <h2
                style={{
                  marginTop: '20px',
                }}
              >
                Marriage Planning Report
              </h2>
            </div>

            <table
              style={{
                width: '100%',
                borderCollapse:
                  'collapse',
              }}
            >
              <tbody>
                <tr>
                  <td
                    style={{
                      border:
                        '1px solid #ddd',
                      padding: '10px',
                    }}
                  >
                    Current Age
                  </td>

                  <td
                    style={{
                      border:
                        '1px solid #ddd',
                      padding: '10px',
                    }}
                  >
                    {currentAge} Years
                  </td>
                </tr>

                <tr>
                  <td
                    style={{
                      border:
                        '1px solid #ddd',
                      padding: '10px',
                    }}
                  >
                    Marriage Age
                  </td>

                  <td
                    style={{
                      border:
                        '1px solid #ddd',
                      padding: '10px',
                    }}
                  >
                    {marriageAge} Years
                  </td>
                </tr>

                <tr>
                  <td
                    style={{
                      border:
                        '1px solid #ddd',
                      padding: '10px',
                    }}
                  >
                    Future Wedding Cost
                  </td>

                  <td
                    style={{
                      border:
                        '1px solid #ddd',
                      padding: '10px',
                    }}
                  >
                    {formatCurrency(
                      result.futureCost
                    )}
                  </td>
                </tr>

                <tr>
                  <td
                    style={{
                      border:
                        '1px solid #ddd',
                      padding: '10px',
                    }}
                  >
                    Total Corpus
                  </td>

                  <td
                    style={{
                      border:
                        '1px solid #ddd',
                      padding: '10px',
                    }}
                  >
                    {formatCurrency(
                      result.totalCorpus
                    )}
                  </td>
                </tr>

                <tr>
                  <td
                    style={{
                      border:
                        '1px solid #ddd',
                      padding: '10px',
                    }}
                  >
                    Goal Achievement
                  </td>

                  <td
                    style={{
                      border:
                        '1px solid #ddd',
                      padding: '10px',
                    }}
                  >
                    {Math.min(
                      result.percentageAchieved,
                      100
                    ).toFixed(1)}
                    %
                  </td>
                </tr>
              </tbody>
            </table>

            <div
              style={{
                marginTop: '30px',
                background: '#f5f7fa',
                padding: '20px',
                borderRadius: '10px',
              }}
            >
              <h3>
                Mutual Fund Disclaimer
              </h3>

              <p
                style={{
                  fontSize: '13px',
                  lineHeight: '24px',
                }}
              >
                Mutual Fund investments
                are subject to market
                risks. Read all scheme
                related documents
                carefully before
                investing.
              </p>
            </div>
          </div>
        </div>
      )}

      {/* BUTTONS */}
      {result && (
        <div className="grid md:grid-cols-2 gap-4 mt-8">
          <button
            onClick={() =>
              setShowForm(true)
            }
            className="flex items-center justify-center gap-3 bg-[#2e56b8] hover:bg-[#24479b] text-white py-4 rounded-2xl font-semibold transition-all duration-300"
          >
            <FaFilePdf />
            Download PDF Report
          </button>

          <button
            onClick={() =>
              setShowForm(true)
            }
            className="flex items-center justify-center gap-3 bg-[#69bf74] hover:bg-[#58ab63] text-white py-4 rounded-2xl font-semibold transition-all duration-300"
          >
            <FaWhatsapp />
            Share on WhatsApp
          </button>
        </div>
      )}

      {/* FORM */}
      {showForm && (
        <CalculatorForm
          onSubmit={handleFormSubmit}
          onClose={() => setShowForm(false)}
          calculatorType="Marriage"
          calculationData={{ ...result, chartData }}
          userInputs={{
            currentAge,
            marriageAge,
            currentMarriageCost,
            inflationRate,
            monthlyInvestment,
            expectedReturn,
            existingSavings,
            annualStepUp,
          }}
        />
      )}
    </motion.div>
  );
};

export default MarriageCalculator;